export const CONSTANTS = {
	status: {
	  okay: 'OK',
	  error: 'ERROR',
	  success: 'Success'
	},
	gigyaConfig: {
	  screenSetId: 'elnuevodia-web-login',
	  loginStartScreenSet: 'gigya-login-screen',
	  updateStartScreenSet: 'gigya-update-screen',
	  changePasswordScreenSet: 'gigya-change-password-screen',
	  registerScreenSet: 'gigya-register-screen',
	  language: 'es',
	  domain: 'micuenta.elnuevodia.com'
	},
	api: {
	  gigyaIdQueryParam: 'GigyaUserID',
	  emailQueryParam: 'Email',
	  customerIdQueryParam: 'CustID',
	  customerAddressIdQueryParam: 'CustAddrID',    
	  paymentMethodIdQueryParam: 'PaymentMethodID',
	  packageIdQueryParam: 'PackageID',
	  subscriptionIdQueryParam: 'SubID',
	  subscriptionEventIdQueryParam: 'SubEventID',
	  creditPromotionsIdQueryParam: 'CreditPromotionsId',
	  ePaymentIdQueryParam: 'EpaymentID',
	  routingNumberQueryParam: 'Number',
	  value1QueryParam: 'Val1',
	  value2QueryParam: 'Val2'
	},
	faqs: {
	  topTenSlug: 'mas-buscadas',
	  faqsQueryParam: 'faqs',
	  categoriesQueryParam: 'categories',
	  perPageQueryParam: 'per_page',
	  numberOfFaqs: '100',
	  numberOfCategories: '30'
	}
  };
  
  


// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/shared/constants.ts